"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IntegrationIcon = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const sanitizeHtml_1 = require("@/app/shared/helpers/sanitizeHtml");
const tooltip_1 = require("primereact/tooltip");
const utils_1 = require("primereact/utils");
const uuid_1 = require("uuid");
const labels_1 = __importDefault(require("../../i18n/labels"));
const IntegrationIconSources = {
    ["GOOGLE_CONTACTS" /* MemberType.GOOGLE_CONTACTS */]: '/assets/images/integration-google.svg',
    ["MICROSOFT_CONTACTS" /* MemberType.MICROSOFT_CONTACTS */]: '/assets/images/integration-microsoft.svg',
    ["HUBSPOT" /* MemberType.HUBSPOT */]: '/assets/images/integration-hubspot.svg',
    ["SALESFORCE" /* MemberType.SALESFORCE */]: '/assets/images/integration-salesforce.svg',
    ["SALESFORCE_CEP" /* MemberType.SALESFORCE_CEP */]: '/assets/images/integration-salesforce-cep.svg',
    ["MS_DYNAMICS" /* MemberType.MS_DYNAMICS */]: '/assets/images/integration-dynamics.svg',
    ["SUMO1" /* MemberType.SUMO1 */]: '',
    ["CUSTOM" /* MemberType.CUSTOM */]: '',
};
const IntegrationIconTypeTooltips = {
    ["GOOGLE_CONTACTS" /* MemberType.GOOGLE_CONTACTS */]: labels_1.default.GMAIL_CONTACTS_TOOLTIP,
    ["MICROSOFT_CONTACTS" /* MemberType.MICROSOFT_CONTACTS */]: labels_1.default.OUTLOOK_CONTACTS_TOOLTIP,
    ["HUBSPOT" /* MemberType.HUBSPOT */]: labels_1.default.HUBSPOT_TOOLTIP,
    ["SALESFORCE" /* MemberType.SALESFORCE */]: labels_1.default.SALESFORCE_TOOLTIP,
    ["SALESFORCE_CEP" /* MemberType.SALESFORCE_CEP */]: labels_1.default.SUMO_FOR_SALESFORCE_CEP_TOOLTIP,
    ["MS_DYNAMICS" /* MemberType.MS_DYNAMICS */]: labels_1.default.SERVICE_NOW_TOOLTIP,
    ["SUMO1" /* MemberType.SUMO1 */]: '',
    ["CUSTOM" /* MemberType.CUSTOM */]: '',
};
const IntegrationIconSubTypeTooltips = {
    ["ANY" /* MemberSubType.ANY */]: '',
    ["LEAD" /* MemberSubType.LEAD */]: labels_1.default.SALESFORCE_LEAD_TOOLTIP,
    ["CONTACT" /* MemberSubType.CONTACT */]: labels_1.default.SALESFORCE_CONTACT_TOOLTIP,
    ["PERSON_ACCOUNT" /* MemberSubType.PERSON_ACCOUNT */]: labels_1.default.SALESFORCE_CONTACT_TOOLTIP,
    ["TEAM" /* MemberSubType.TEAM */]: labels_1.default.SALESFORCE_TEAM_TOOLTIP,
    ["RESOURCE" /* MemberSubType.RESOURCE */]: labels_1.default.SALESFORCE_RESOURCE_TOOLTIP,
    ["BUCKET" /* MemberSubType.BUCKET */]: labels_1.default.SALESFORCE_BUCKET_TOOLTIP,
    ["USER" /* MemberSubType.USER */]: labels_1.default.SALESFORCE_USER_TOOLTIP,
};
const IntegrationIcon = ({ option, className }) => {
    const iconSource = option?.type && IntegrationIconSources[option.type];
    const typeTooltipText = option?.type && IntegrationIconTypeTooltips[option.type];
    const subTypeTooltipText = option?.subType && IntegrationIconSubTypeTooltips[option.subType];
    const tooltipText = option?.type === "SALESFORCE" /* MemberType.SALESFORCE */ && subTypeTooltipText ? `${typeTooltipText} - ${subTypeTooltipText}` : typeTooltipText;
    const uniqueId = `info-${(0, uuid_1.v4)()}`;
    if (!iconSource || !tooltipText)
        return null;
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(tooltip_1.Tooltip, { className: 'max-w-240px', position: 'top', target: `#${uniqueId}`, autoHide: false, children: (0, jsx_runtime_1.jsx)("span", { dangerouslySetInnerHTML: { __html: (0, sanitizeHtml_1.sanitizeHtml)(tooltipText) } }) }), (0, jsx_runtime_1.jsx)("img", { src: iconSource, id: uniqueId, className: (0, utils_1.classNames)(`icon-24px`, className) })] }));
};
exports.IntegrationIcon = IntegrationIcon;
